<!--
 * @Description:服务管理服务项目新增和编辑所用的对话框组件
 * @Author:sunhuihong
 * @Date: 2022-05-25 12:56:28
 * @LastEditTime: 2023-12-25 13:30:08
-->
<template>
  <div class="body" >
    <el-dialog  width="1200px" :title="dialogTitle" :visible.sync="showHserviceDetails" 
      :close-on-click-modal="false" @open="initData" :before-close='handleCancel' center>
      <div id="dialog-content" class="hsvc-content">
        <el-steps :active="active" finish-status="success" align-center style="padding: 0 100px">
          <el-step title="基本信息" :status="stepStatus(0)"></el-step>
          <el-step title="服务内容" :status="stepStatus(1)"></el-step>
          <el-step title="服务事项" :status="stepStatus(2)"></el-step>
          <el-step title="服务套餐" :status="stepStatus(3)"></el-step> 
        </el-steps>
        <div class="dialog-body">
          <baseinfo-panel  v-if="active == 0" @panel-operate="handlePanelOperate"/>
          <service-content-panel  v-if="active == 1" @panel-operate="handlePanelOperate"/>
          <service-items-panel  v-if="active == 2" @panel-operate="handlePanelOperate"/>
          <service-package-panel  v-if="active == 3" :hsvcId="hsvcId" @panel-operate="handlePanelOperate"/>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import hserviseStore from './hservicedetails/HserviceDetailStore'

import BaseInfoPanel from "./hservicedetails/BaseInfoPanel.vue";
import ServiceContentPanel from "./hservicedetails/ServiceContentPanel";
import ServiceItemsPanel from "./hservicedetails/ServiceItemsPanel";
import ServicePackagePanel from "./hservicedetails/ServicePackagePanel";

let HserviceDetails = {
  name: 'HserviceDetails',
  components: { 
    'baseinfo-panel': BaseInfoPanel,
    'service-content-panel': ServiceContentPanel,
    'service-items-panel': ServiceItemsPanel,
    'service-package-panel': ServicePackagePanel,
  },
  
  hserviseStore,
  props: ["showHserviceDetails", "mode", "hsvcId", "institutionId"],
  data() {
    return {
      active: 0,
    }
  },

  computed: {
    dialogTitle() {
      switch (this.mode) {
        case 'add'    : return "新增服务";
        case 'edit'   : return "编辑服务";
        case 'details': return "服务详情";
        default       : return "----";
      } 
    },
    
    stepStatus() {
      return function(curActive) {
        return (curActive <= this.active) ? 'finish' : 'wait';
      }
    },
  },

  methods: {
    initData() {
      this.clearData();
      hserviseStore.commit("changeMode", this.mode);
      this.active = 0;
      this.queryData();
    },

    queryData() {
      let url = '';
      switch (this.mode) {
        case 'add': 
          url = Constant.URL_GET_HSERVICE_DO_4_ADD
          break;
        case 'edit': 
          url = Constant.URL_GET_HSERVICE_DO_4_UPDATE;
          break;
        case 'details': 
          url = Constant.URL_GET_HSERVICE_DETAILS_DO;
          break;
      }
      let params = this.mode == 'add' ? {} : {id: this.hsvcId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: url,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };

      this.vueRequest(requestData).then(result => {
        if (result != null) {
          let hsvcDo = result.data;
          if (this.mode == 'add') {
            this.clearOrignData(hsvcDo);
          }
          if (this.mode == 'details') {
            hserviseStore.commit("changeServiceCfg", hsvcDo.hservice);
            hserviseStore.commit('changeServiceItemCfgList', hsvcDo.hserviceItemList);
            hserviseStore.commit('changeMatterCfgBaseInfoDO', hsvcDo.hserviceMatter);
            hserviseStore.commit('changeServicePkgCfgList', hsvcDo.hservicePkgList); 
            hserviseStore.commit("changeModeMap", hsvcDo.modeMap);
          } else {
            hserviseStore.commit("changeServiceCfgBaseInfoDO",hsvcDo.hserviceBaseInfoDO);
            hserviseStore.commit("changeServiceCfg",hsvcDo.hserviceBaseInfoDO.hservice);
            hserviseStore.commit('changeSvcTypeCfgDOList', hsvcDo.hserviceBaseInfoDO.openingHserviceDOList);
            hserviseStore.commit('changeInstitutionList', hsvcDo.hserviceBaseInfoDO.institutionList);
            hserviseStore.commit("changeModeMap", hsvcDo.hserviceBaseInfoDO.modeMap);
            hserviseStore.commit('changeSloganList', hsvcDo.hserviceBaseInfoDO.sloganList);
            hserviseStore.commit('changeServiceItemCfgList', hsvcDo.hserviceItemList);
            hserviseStore.commit('changeMatterCfgBaseInfoDO', hsvcDo.hserviceMatter);
            hserviseStore.commit('changeServicePkgCfgList', hsvcDo.hservicePkgList); 
          }
        }
      })

    },

    clearOrignData(hsvcDo) {
      hsvcDo.hserviceBaseInfoDO.hservice.institutionId = this.institutionId;
      hsvcDo.hserviceBaseInfoDO.hservice.hserviceTypeCfgId = null;
      hsvcDo.hserviceBaseInfoDO.hservice.mode = 3;
      hsvcDo.hservicePkgList[0].curPriceYuan = '';
      hsvcDo.hservicePkgList[0].originalPriceYuan = '';
      hsvcDo.hservicePkgList[0].serviceDuration = '';
    },

    clearData() {
      this.active = 0;
      hserviseStore.commit('changeServiceCfg', {});
      hserviseStore.commit('changeUserFile', null);  
      hserviseStore.commit('changeServiceFile',null);    
    },

    handlePanelOperate(opr) {
      document.getElementById("dialog-content").scrollTop = 0;
      switch(opr) {
        case 'prev': 
          this.handlePrev();
          break;
        case 'next':
          this.handleNext();
          break;
        case 'ok':
          this.handleCancel();
          break;
        case 'add':
        case 'edit':
          this.handleSubmit(opr);
          break;
        case 'cancel':
          this.handleCancel();
          break;
      }
    },

    handlePrev() {
      if (this.active > 0) this.active--;
    },

    handleNext() {
      if (this.active < 3) this.active++;
    },
    
    handleSubmit(_opr) {
      let url = (this.mode == 'add') ? Constant.URL_SAVE_HSERVICE : Constant.URL_UPDATE_HSERVICE;
      let hserviceCfgData = hserviseStore.state.serviceCfg;
      delete hserviceCfgData.timeRange;
      let obj = {
        "hservice": hserviceCfgData,
        "hserviceMatter": hserviseStore.state.matterCfgBaseInfoDO,
        "hserviceItem": hserviseStore.state.serviceItemCfgList,
        "hservicePkgList": hserviseStore.state.servicePkgCfgList};
      let fileMap = new Map();
      if (hserviseStore.state.userFile && hserviseStore.state.userFile.raw) {
        fileMap.set('suitableImageFile', hserviseStore.state.userFile.raw)
      }
      if (hserviseStore.state.serviceFile && hserviseStore.state.serviceFile.raw) {
        fileMap.set('svcImageFile', hserviseStore.state.serviceFile.raw)
      }
      let params = {'name': 'hserviceVO', 'value': {...obj}};
      let [header, esParams] = this.encryptionUtil.encryptAndSignObjectParam(
				params, Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY, 
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        url: url,
        method: (this.mode == 'add') ? 'POST' : 'PUT',
        header: header,
        param: esParams,
        files: fileMap,
        contentType: this.commonConst.CNTYPE_JSON,
      };

      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.clearData();
          if (this.mode == 'add') {
            this.$emit("close-dialog", true, result.data);
          } else {
            this.$emit("close-dialog", true);
          }
        }
      })    
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },
  },
}
export default HserviceDetails
</script>

<style scoped>
.dialog-body {
  padding: 0;
  margin:0;
}
.hsvc-content {
  max-height: 75vh; 
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/hsvcmng/components/HserviceDetails.vue